
import React from 'react';
import '../../resources/css/notice-page.css';
import i18n from '../../i18n';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import { BusinessMenu } from '../../constants/type.constant';
import _ from 'lodash';
import { Typography } from '@material-ui/core';

class OpeningHoursComponent extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    constructor(props: Props) {
        super(props);
        this.state = {

        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************
    public UNSAFE_componentWillMount() {

    }
    public componentDidMount() { }


    // *********************
    // 方法区
    // *********************


    // *********************
    // 视图区
    // *********************

    render() {
        const { scheduleData, isNew } = this.props;
        return (
            <React.Fragment>
                {
                    !!scheduleData.length &&

                    <div style={{ flex: 3 }}>
                        <div className="homeTitle">{i18n.t('auto_open_page_text_opening_hours')}</div>
                        <div style={{ backgroundColor: '#5D658E', borderRadius: 15, padding: '10px 15px' }}>
                            {
                                _.chunk(scheduleData, 2).map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                fontSize: 14,
                                                lineHeight: '30px'
                                            }}
                                        >
                                            {
                                                item.map((k, idx) => {
                                                    return (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                                color: '#00CCCC'
                                                            }}
                                                        >
                                                            {
                                                                (k.start_time === k.end_time) && (k.start_time === '00:00')
                                                                    ?
                                                                    i18n.t('general_text_all_day_business')
                                                                    :
                                                                    `${(k.start_time).slice(0, 5)} - ${(k.end_time).slice(0, 5)}`
                                                            }
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <Typography className='opening-hours-tip'>
                            {isNew ? i18n.t('general_text_compound_business_hours') : i18n.t('general_text_business_hours')}
                        </Typography>
                    </div>
                }
            </React.Fragment>
        )
    }

}
export default withSnackbar(OpeningHoursComponent);

// *********************
// TYPE
// *********************

type Props = {
    // 营业时间数据
    scheduleData: Array<BusinessMenu>;
    // 当前的新营业时间还是旧营业时间
    isNew: Boolean;

} & WithSnackbarProps

type State = {

}
